<template>
  <vxe-grid
    ref="processTable"
    auto-resize
    highlight-hover-row
    resizable
    border
    :data="tableData"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    :height="height"
    size="mini"
    class="workshop-process-table"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:drag>
      <span class="drag-btn">
        <i class="vxe-icon--menu"></i>
      </span>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="$emit('openEditDialog', { type: 'detail', data: row })"
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="$emit('openEditDialog', { type: 'edit', data: row })"
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i class="el-icon-delete tool-btn" @click="del(row)"></i>
        </el-tooltip>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
import Sortable from 'sortablejs'
import { format } from '@/libs/util.number.js'
export default {
  props: {
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    refresh: { type: Boolean, default: false },
    height: { type: Number, default: 400 },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      format: (number) => format(number),
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!this.tableData || JSON.stringify(this.tableData) == '[]') {
          this.tableData = [...val]
        }
      },
      immediate: true,
    },
  },
  computed: {
    tableToolbar() {
      return {
        slots: { buttons: 'toolbar_form' },
        refresh: !this.refresh ? null : { query: () => this.$emit('reload') },
      }
    },
  },
  created() {
    this.rowDrop()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    reloadTableData(data) {
      this.tableData = []
      setTimeout(() => {
        this.tableData = [...data]
      }, 0)
    },
    async getTableData() {
      return this.tableData
    },
    async spliceRow(index, row) {
      const data = await this.getTableData()
      if (!data || !data.length) return false
      data[index] = { ...row }
      setTimeout(() => {
        this.tableData = [...data]
        this.$emit('change', this.tableData)
      }, 0)
      return true
    },
    async insert(row) {
      this.tableData.push(row)
      this.$emit('change', this.tableData)
    },
    async removeByRows(rows) {
      if (!rows || !rows.length) return

      rows.forEach(async (row) => {
        await this.removeByIndex(this.$refs.processTable.getRowIndex(row))
      })
      this.$emit('change', this.tableData)
    },
    async removeByIndex(index) {
      this.tableData.splice(index, 1)
      this.$emit('change', this.tableData)
    },
    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        await this.removeByIndex(this.$refs.processTable.getRowIndex(row))
        this.$emit('change', this.tableData)
        this.$emit('del-change', [row])
      })
    },
    async getCheckboxRecords() {
      return await this.$refs.processTable.getCheckboxRecords()
    },
    removeCheckboxRow() {
      const data = this.$refs.processTable.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      this.$refs.processTable.removeCheckboxRow()
    },
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.processTable
        this.sortable = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              if (newIndex == oldIndex) return

              const data = [...this.tableData]
              const currRow = data[oldIndex]

              if (newIndex > oldIndex) {
                for (let i = oldIndex + 1; i <= newIndex; i++) {
                  data[i - 1] = data[i]
                }
              } else {
                for (let i = oldIndex - 1; i >= newIndex; i--) {
                  data[i + 1] = data[i]
                }
              }
              data[newIndex] = currRow
              this.tableData = []
              setTimeout(() => {
                this.tableData = [...data]
                this.$emit('change', this.tableData)
                this.$emit('drop-change', this.tableData)
              }, 0)
            },
          }
        )
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.workshop-process-table .drag-btn {
  cursor: move;
  font-size: 12px;
}
</style>
